(function(){
  function patchLabels() {
    document.querySelectorAll('summary, button, label, span, h2, h3').forEach(function(el){
      if (!el || !el.childNodes) return;
      el.childNodes.forEach(function(n){
        if (n.nodeType === 3 && n.nodeValue) {
          var v = n.nodeValue;
          if (v.indexOf('Disponibilit\u00e9') !== -1) n.nodeValue = v.replace(/Disponibilit\u00e9/g, 'Availability');
        }
      });
    });
  }
  function dedupeH1() {
    // On non-home pages, keep only the FIRST H1 (the page H1) — convert any extra H1 to H2
    var isHome = location.pathname === '/' || location.pathname === '';
    var h1s = document.querySelectorAll('h1');
    if (h1s.length < 2) return;
    if (isHome) {
      // On home, demote logo H1 (the visually-hidden or logo wrapper) to a span
      h1s.forEach(function(h, i){
        var isLogo = h.closest('.header__heading, [class*="logo"], a.logo, header h1');
        if (isLogo) {
          var span = document.createElement('span');
          span.className = h.className;
          for (var i2 = h.attributes.length - 1; i2 >= 0; i2--) {
            var a = h.attributes[i2];
            if (a.name !== 'class') span.setAttribute(a.name, a.value);
          }
          while (h.firstChild) span.appendChild(h.firstChild);
          h.replaceWith(span);
        }
      });
    } else {
      // On non-home, keep the first content H1 (product title / collection title), demote others
      var seenContent = false;
      h1s.forEach(function(h){
        var isLogo = h.closest('.header__heading, [class*="logo"], a.logo, header h1');
        if (isLogo) {
          var span = document.createElement('span');
          span.className = h.className;
          for (var i = h.attributes.length - 1; i >= 0; i--) {
            var a = h.attributes[i];
            if (a.name !== 'class') span.setAttribute(a.name, a.value);
          }
          while (h.firstChild) span.appendChild(h.firstChild);
          h.replaceWith(span);
          return;
        }
        if (seenContent) {
          // Demote second content H1 to H2
          var h2 = document.createElement('h2');
          h2.className = h.className;
          for (var i = h.attributes.length - 1; i >= 0; i--) {
            var a = h.attributes[i];
            if (a.name !== 'class') h2.setAttribute(a.name, a.value);
          }
          while (h.firstChild) h2.appendChild(h.firstChild);
          h.replaceWith(h2);
        } else {
          seenContent = true;
        }
      });
    }
  }
  function init() { patchLabels(); dedupeH1(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  setTimeout(init, 300);
  setTimeout(init, 1200);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('on:facets:rendered', patchLabels);
})();